import PropTypes from "prop-types";
import PageLoader from "../loaders/page-loader.component";

const AccountCreationModal = ({ state, message }) => {
  if (!state) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden">
        <div className="p-8 flex flex-col items-center justify-center">
          <PageLoader size={80} className="mb-4" />
          
          <h3 className="text-lg font-bold text-center text-gray-800 mb-2">
            {message || "Creating your account..."}
          </h3>
          <p className="text-sm text-center text-gray-500">
            This may take a moment. Please don&apos;t close this window.
          </p>
        </div>
      </div>
    </div>
  );
};

AccountCreationModal.propTypes = {
  state: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

export default AccountCreationModal;